import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const CANONICAL_ORIGIN = 'https://hirolainfotech.com';

const CanonicalURL = () => {
  const { pathname } = useLocation();

  // Never expose admin/auth utility routes as indexable canonical pages.
  const isNoIndexRoute =
    /^\/(admin|admin-panel)(\/|$)/i.test(pathname) ||
    /^\/(select|sitemap)(\/|$)/i.test(pathname);

  const normalizedPath =
    pathname === '/' ? '/' : `/${pathname.replace(/^\/+|\/+$/g, '')}/`;

  const canonical = `${CANONICAL_ORIGIN}${normalizedPath}`;

  return (
    <Helmet>
      {!isNoIndexRoute && <link rel="canonical" href={canonical} />}
      {isNoIndexRoute && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default CanonicalURL;
